import { onLogout } from '../../session/logout'
import { getAccountsURL } from '../../tenant/utils/parse-accounts'
import * as Sentry from '@sentry/react';

const validateEmptyScreen = (timeoutSeconds: number = 5): void => {
  const timeout = setTimeout(() => {
    const rootElement = document.getElementById('root')
    const hasContent = rootElement !== null && rootElement.innerHTML.trim().length > 0
    if (!hasContent) {
      Sentry.captureEvent({
        message: "Architecture Empty Screen",
        level: "warning",
        extra: {
          ...window.location
        }
      });
      onLogout()
        .then(() => {
          if (typeof process.env.URL_LOGIN !== 'undefined') {
            window.location.href = getAccountsURL()
          } else {
            window.location.pathname = `${typeof process.env.BASENAME !== 'undefined' ? process.env.BASENAME : ''}/accounts/login`
          }
        })
        .catch(console.error)
    }

    clearTimeout(timeout)
  }, timeoutSeconds * 1000)
}

export default validateEmptyScreen
